<script setup lang="ts">
import { computed, defineAsyncComponent } from 'vue'
import { RouterView, useRoute } from 'vue-router'

import { useTheme } from '@/composables/useTheme'

const PublicLayout = defineAsyncComponent(() => import('@/layouts/PublicLayout.vue'))
const AuthenticatedLayout = defineAsyncComponent(() => import('@/layouts/AuthenticatedLayout.vue'))
const SiteLayout = defineAsyncComponent(() => import('@/layouts/SiteLayout.vue'))
const ClientLayout = defineAsyncComponent(() => import('@/layouts/ClientLayout.vue'))

// Aplica el color de acento configurado en el admin (variables CSS en vivo).
useTheme()

const route = useRoute()

const Layout = computed(() => {
  const meta = route.meta as { layout?: string } | undefined
  const name = meta?.layout
  if (name === 'site') return SiteLayout
  if (name === 'portal') return ClientLayout
  if (name === 'public' || name === 'blank') return PublicLayout
  return AuthenticatedLayout
})
</script>

<template>
  <component :is="Layout">
    <RouterView v-slot="{ Component, route: r }">
      <Transition
        name="fade"
        mode="out-in"
      >
        <Suspense>
          <component
            :is="Component"
            :key="r.fullPath"
          />
          <template #fallback>
            <div class="flex h-full min-h-[40vh] w-full items-center justify-center">
              <span class="pi pi-spin pi-spinner text-3xl text-slate-400" />
            </div>
          </template>
        </Suspense>
      </Transition>
    </RouterView>
  </component>
</template>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
